import { Estado } from 'app/shared/interfaces/estado';
import { Cidade } from 'app/shared/interfaces/cidade';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, tap, switchMap, finalize, catchError, delay, filter, map, takeUntil } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { PageResult } from 'app/shared/interfaces/page-result';
import { CidadeService } from 'app/shared/services/cidade.service';
import { CepService } from 'app/shared/services/cep.service';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { CadastroVendedor } from 'app/shared/interfaces/cadastro-vendedor';
import { TipoCadastro } from 'app/shared/inmemory-db/tipo-cadastro';
import { Console } from 'console';

@Component({
  selector: 'app-vendedor-popup',
  templateUrl: './vendedor-popup.component.html',
  styleUrls : ['./vendedor-popup.component.scss']
})
export class VendedorPopupComponent implements OnInit {

  public vendedorForm: FormGroup;

  cadastroVendedor: CadastroVendedor;
  vendedores: Cadastro[] = [];
  vendedor: Cadastro;
  isLoadingVendedor = false;

  isLoading = false;
  isLoadingGrupo = false;
  isLoadingCep = false;
  selectedTabIndex = 0;
  errorMsg: string;
  public searching = false;

  protected _onDestroy = new Subject<void>();
  


  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VendedorPopupComponent>,
    private fb: FormBuilder, private cidadeService: CidadeService,
    private cepService: CepService,
    private confirmService: AppConfirmService,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit() {
    
    this.buildItemForm(this.data.payload);

    this.cadastroVendedor = this.data.payload;

    
    if (this.cadastroVendedor.vendedor !== undefined && this.cadastroVendedor.vendedor !== null) {
      this.vendedores.push(this.cadastroVendedor.vendedor);
      this.vendedorForm.controls['vendedor'].setValue(this.cadastroVendedor.vendedor);
    }

    /**
     * Search Vendedor
     */
    this.vendedorForm.get('searchVendedor').valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.vendedores) {
            return [];
          }
          return this.cadastroService.getCadastroPageSearch(1, 10, search, null, null, false, TipoCadastro.VENDEDORES).subscribe(vendedores => {
            this.vendedores = vendedores.content;
          });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(result => {
        this.searching = false;
        if (this.cadastroVendedor.vendedor !== undefined && this.cadastroVendedor.vendedor !== null) {
          if (this.vendedores.map(n => n.id).includes(this.cadastroVendedor.vendedor.id)) {
            const vend = this.vendedores.find(n => n.id === this.cadastroVendedor.vendedor.id) ?? this.cadastroVendedor.vendedor;
            if (vend !== null && vend !== undefined) {
              this.vendedorForm.controls['vendedor'].setValue(vend);
            }
          } else {
            this.vendedores.push(this.cadastroVendedor.vendedor);
          }
        }
      },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO VENDEDOR/REPRESENTANTE ... ${error}`,
              error: true
            });
        });

  }

  onSelectionChangeVendedor(event: any): void {
    if (event.value !== undefined) {
      this.vendedor = event.value;
    }
  }

  buildItemForm(cadastroVendedor: CadastroVendedor) {
    this.vendedorForm = this.fb.group({
      id: [cadastroVendedor.id],
      uuid: [cadastroVendedor.uuid],
      cadastro: [cadastroVendedor.cadastro],
      vendedor: [cadastroVendedor.vendedor],
      searchVendedor: ''
    })

    }

  submit() {
   this.dialogRef.close(this.vendedorForm.value)
  }
 

  save() {
    this.cadastroService.saveOrUpdateVendedor(this.vendedorForm.value).subscribe(
      val => {
        console.log(val);
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, Vendedor/Representante Salvo com Sucesso!', error: false
        });
      },
      err => {
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR VENDEDOR/REPRESENTANTE, VERIFIQUE',
          message: err.error.status, error: true
        })
      });
  }

}
